<!--
할당 원클릭 변경 컴포넌트
- 모달 없이 인라인 버튼으로 할당을 즉시 변경
-->
<template>
    <span class="allocate-buttons">
        <button
            v-for="option in allocateToOptions"
            :key="option.val"
            type="button"
            class="uk-button uk-button-xsmall"
            :class="option.val === activeTo ? 'uk-button-primary' : 'uk-button-default'"
            :disabled="submitting"
            @click="changeAllocate(option.val)"
        >
            {{ option.text }}
        </button>
    </span>
</template>

<script>
    export default {
        props: {
            csrfToken: {
                type: String,
                required: true,
            },
            cmId: {
                type: Number,
                required: true,
            },
            currentAllocateTo: {
                type: Number,
                required: true,
            },
            allocateRegionId: {
                type: Number,
                default: null,
            },
            allocateUserId: {
                type: Number,
                default: null,
            },
            allocateUserNick: {
                type: String,
                default: null,
            },
            onlyGeneralOrUser: {
                type: Boolean,
                default: false,
            },
        },
        data: function () {
            return {
                activeTo: this.currentAllocateTo,
                submitting: false,
            };
        },
        computed: {
            allocateToOptions() {
                const options = [];

                options.push({
                    text: '한국총괄',
                    val: 1,
                });

                if (this.allocateRegionId) {
                    options.push({
                        text: '창고',
                        val: 2,
                    });
                }

                if (this.allocateUserId) {
                    let user_text = '사용자';
                    if (this.onlyGeneralOrUser && this.allocateUserNick) {
                        user_text += '(' + this.allocateUserNick + ')';
                    }
                    options.push({
                        text: user_text,
                        val: 3,
                    });
                }

                options.push({
                    text: 'EMPTY',
                    val: 9,
                });

                return options;
            },
        },
        methods: {
            changeAllocate(val) {
                if (val === this.activeTo || this.submitting) {
                    return;
                }

                this.submitting = true;

                $.app.ajax.module.default({
                    type: 'patch',
                    url: '/communications/' + this.cmId + '/allocate',
                    data: {
                        '_token': this.csrfToken,
                        'allocate_to': val,
                        'allocate_region_id': this.allocateRegionId,
                        'allocate_user_id': this.allocateUserId,
                    },
                    success: (response) => {
                        UIkit.modal.alert('저장되었습니다.').then(() => {
                            $.app.refresh();
                        });
                    },
                    error: () => {
                        this.submitting = false;
                    },
                });
            },
        },
    }
</script>

<style lang="scss" scoped>
    .allocate-buttons {
        .uk-button + .uk-button {
            margin-left: 4px;
        }
    }
</style>
